
import { mapState } from 'vuex'
import HeadBanner from '~/components/common/HeadBanner'
import NavConfig from '@/modules/config/nav'
import Clipboard from 'clipboard'
import commonMixin from '@/mixins/common'

export default {
  components: {
    HeadBanner,
  },
  mixins: [commonMixin],
  props: {
    result: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      name: '',
      content: '',
    }
  },
  head() {
    return {
      title: this.$t(`modules.about.relations`) + this.$t('navs.suffixName'),
    }
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isHdFtMobile,
      site: (state) => state.site,
      lang: (state) => state.lang,
    }),
    service() {
      return this.result
    },
    kefu() {
      return NavConfig[this.site]?.kefu[this.lang] || '/'
    },
  },
  mounted() {
    this.initClipboard()
  },
  methods: {
    onChatClick() {
      window.open(this.kefu, '_blank')
    },
    initClipboard() {
      this.clipboard = new Clipboard('.copy-clipboard')
       this.clipboard.on('success', () => {
        this.$message.success(this.$t('common.form.copySuccess'))
      })
      this.clipboard.on('error', () => {
        this.$message.error(this.$t('common.form.copyFailed'))
      })
    },
    handleClickPhone(val) {
      let a = document.createElement('a')
      a.href = `tel:${val}`
      a.click()
    },
    handleClickWhatsApp(val) {
      window.open(val, '_blank')
    },
    // 打开邮件客户端
    sendEmail() {
      const email = 'cs1_sg@sf-express.com'
      const mailtoUrl = `mailto:${email}`

      // 使用隐藏的 a 标签触发 mailto，避免浏览器弹出空白页
      const link = document.createElement('a')
      link.href = mailtoUrl
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
}
